/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_SubtitleInputs */

const zh_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让每一位教育者都能轻松创作高质量的课程、练习与反馈。`)
};

const en_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empowering every educator to create high-quality lessons, exercises, and feedback.`)
};

const es_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empoderamos a cada educador para crear lecciones, ejercicios y retroalimentación de alta calidad.`)
};

/**
* | output |
* | --- |
* | "Empowering every educator to create high-quality lessons, exercises, and feedback." |
*
* @param {Landing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_hero_subtitle = /** @type {((inputs?: Landing_Hero_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_hero_subtitle(inputs)
	if (locale === "en") return en_landing_hero_subtitle(inputs)
	return es_landing_hero_subtitle(inputs)
});